import { actionTypes } from './actions';
import initialState from './initialState';

export default function cameralAuditsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return state.set('loading', true).set('error', null);
    case actionTypes.REQUEST_SUCCESS:
      return state.set('loading', false).set('data', action.payload);
    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    case actionTypes.GET_YEARS_START:
      return state.set('loading', true).set('error', null);
    case actionTypes.GET_YEARS_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    case actionTypes.GET_YEARS_SUCCESS:
      return state.set('loading', false).set('years', action.payload);
    case actionTypes.GET_CAMERAL_FOR_DOCUMENT_ID_START:
      return state.set('loading', true).set('error', null);
    case actionTypes.GET_CAMERAL_FOR_DOCUMENT_ID_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    case actionTypes.GET_CAMERAL_FOR_DOCUMENT_ID_SUCCESS:
      return state.set('loading', false).set('data', action.payload);
    default:
      return state;
  }
}
